export default "Solution Éco France (SAS, SIREN 982 431 033) : acteur intégré — travaux & rénovation, courtage énergie B2B, mandataire CEE. Modèle économique transparent.";
